import { Response } from 'shared/models/general.ts'
import { TicketItem } from 'shared/models/ticket'

import { clientApi } from './clientApi'

export const RulesApi = {
  getRule(
    detail: Pick<TicketItem, 'tid' | 'source' | 'uid'>,
    signal?: AbortSignal,
  ) {
    return clientApi.get<Response<string>>('flights/rules', {
      params: { ...detail },
      signal,
    })
  },
}
